const renderClearRefinements = instantsearch.connectors.connectClearRefinements(
	(renderOptions, isFirstRender) => {

		const { canRefine, refine, widgetParams } = renderOptions;

		if (isFirstRender) {
			const button = document.createElement('button');
			button.textContent = 'Clear All';
		
			button.addEventListener('click', () => {
				refine();
				const chiclets = document.querySelectorAll('.brookings-chiclet');
				chiclets.forEach( (chiclet) => {
					chiclet.remove();
				});
			});
		
			widgetParams.container.appendChild(button);
		}
	
		widgetParams.container.querySelector('button').disabled = !canRefine;
	}
);
  
export default renderClearRefinements;